// AutoGlim 导航：悬停即展开（复用 Dawn 原生 details[open] 逻辑，避免与层级/定位打架）
// ★ 2026-10-21: 纯 CSS 强行显示下拉时被 hero 盖住（实测 elementFromPoint 命中 slideshow）⚠️
//   → 改为 JS 触发原生 click，交给主题自己的 open 状态与层级 ✅
(function () {
  var mq = window.matchMedia('(min-width: 990px)');

  // ★ 面板右侧推广卡（图/文案/链接由 Liquid 注入 window.AG_NAV_PROMOS）
  function injectPromo(det) {
    var sum = det.querySelector('summary');
    var ul = det.querySelector('.header__submenu');
    if (!sum || !ul || ul.querySelector('.ag-nav-promo')) return;
    var label = (sum.innerText || '').trim();
    // ★ 品牌面板要列全 40 个品牌 → 打标记走 4 列布局，且**不放推广卡**（否则挤不下）
    if (/vehicle/i.test(label)) { ul.classList.add('ag-nav-brands'); return; }
    var p = (window.AG_NAV_PROMOS || {})[label];
    if (!p) return;
    var li = document.createElement('li');
    li.className = 'ag-nav-promo';
    li.style.gridColumn = '3';
    li.style.gridRow = '1 / span 8';
    li.innerHTML = '<a href="' + p.url + '" class="ag-nav-promo__card">' +
      '<img src="' + p.img + '" alt="" loading="lazy">' +
      '<span class="ag-nav-promo__txt"><b>' + p.title + '</b><i>' + p.sub + '</i>' +
      '<u>Shop now \u2192</u></span></a>';
    ul.appendChild(li);
  }

  function bind() {
    var nav = document.querySelector('header .header__inline-menu');
    if (!nav || nav.dataset.agHover === '1') return;
    nav.dataset.agHover = '1';
    nav.querySelectorAll('details').forEach(function (det) {
      var sum = det.querySelector('summary');
      if (!sum) return;
      var t = null;
      // ★ 面板夹在视口内：以 left 像素位移计算 ✗ 用 right:0 是相对菜单项，1024/1280 仍出屏 ⚠️
      function clampPanel() {
        var ul = det.querySelector('.header__submenu');
        if (!ul) return;
        var pad = 12;
        ul.style.left = '0px';
        ul.style.right = 'auto';
        var b = ul.getBoundingClientRect();
        var shift = 0;
        if (b.right > window.innerWidth - pad) {
          shift = (window.innerWidth - pad) - b.right;
        }
        if (b.left + shift < pad) {
          shift = pad - b.left;
        }
        ul.style.left = Math.round(shift) + 'px';
      }
      function open() {
        if (!mq.matches) return;
        clearTimeout(t);
        nav.querySelectorAll('details[open]').forEach(function (o) { if (o !== det) o.removeAttribute('open'); });
        det.setAttribute('open', '');
        sum.setAttribute('aria-expanded', 'true');
        clampPanel();
      }
      function close() {
        if (!mq.matches) return;
        t = setTimeout(function () {
          det.removeAttribute('open');
          sum.setAttribute('aria-expanded', 'false');
        }, 160);
      }
      det.addEventListener('mouseenter', function () { open(); injectPromo(det); });
      det.addEventListener('mouseleave', close);
      det.addEventListener('focusin', open);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);

  // ★ 幻灯片整屏可点（图上的 CTA 是烧死的，点不了 → 这里补真实跳转）
  function bindSlides() {
    document.querySelectorAll('.slideshow .slideshow__slide').forEach(function (sl) {
      if (sl.dataset.agClick === '1') return;
      var a = sl.querySelector('.ss-slide-link');
      if (!a || !a.getAttribute('href')) return;
      sl.dataset.agClick = '1';
      var media = sl.querySelector('.slideshow__media');
      if (!media) return;
      media.style.cursor = 'pointer';
      media.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        window.location.href = a.getAttribute('href');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSlides);
  } else {
    bindSlides();
  }
})();
